import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=12b0e4af&"
import script from "./CategoryView.vue?vue&type=script&lang=ts&"
export * from "./CategoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports